import { useTranslation } from 'react-i18next';
import SlotToggleRow from './SlotToggleRow';

interface RecurringToggleRowProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  // v2-task-P3 — mirrors AutoSelectToggleRow's `disabled`: the per-pickup
  // "change slot" edit modal reuses this row to govern the STANDING
  // recurring-pickup preference, which is meaningless without a preferred
  // slot to request pickups against. When disabled, the Switch is inert and
  // the description is replaced by the SAME muted hint the auto-select row
  // already uses (no new i18n string needed — the message applies verbatim).
  disabled?: boolean;
  // Forwarded to SlotToggleRow — false inside SlotModal's merged card.
  bordered?: boolean;
  // Forwarded to SlotToggleRow — compact one-line layout inside the automation strip.
  compact?: boolean;
}

// v2-task-10fe (spec §4.4) — the recurring-pickup toggle: a SECOND bordered
// row rendered directly below the T9 auto-select row in SlotModal's
// preference mode, sharing the exact same construction via SlotToggleRow.
// Unlike auto-select, recurring is independent of a passed window (it's just
// "auto-request my ready orders daily"), so it has NO preview/warning
// slot — just label + description + switch, seeded from
// setting.recurring_pickup_enabled (default false).
const RecurringToggleRow = ({
  checked,
  onChange,
  disabled = false,
  bordered = true,
  compact = false,
}: RecurringToggleRowProps) => {
  const { t } = useTranslation();

  return (
    <SlotToggleRow
      label={String(t('recurring_pickup_toggle_label'))}
      description={String(
        t(compact ? 'recurring_pickup_toggle_helper_short' : 'recurring_pickup_toggle_description'),
      )}
      disabledHint={String(t('auto_select_toggle_disabled_hint'))}
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      bordered={bordered}
      compact={compact}
    />
  );
};

export default RecurringToggleRow;
